/* Stykhia portrait buy block (templates/product.portrait.json).
   Never submits the form and never replaces Dawn's submit: it only
   - turns Pets → Format → Size → Frame into ONE variant id in the form's hidden input[name="id"],
     updates the price, the price in the button, ?variant= in the URL;
   - shows the photo and name fields for the chosen number of pets; the others are hidden and disabled
     (not required, not sent), and a chosen photo or typed name stays when the number changes;
   - points the style links at the neighbour variant with the same pets, size and frame;
   - carries typed names and chosen options to the neighbour page (sessionStorage, same tab only);
   - stops the Add to Cart click while a required field is empty (the form has novalidate), shows the
     message next to the field and scrolls to the first one. With everything filled the click goes on untouched.
     The sticky bar's button (assets/sm-sticky-cta.js) clicks the same button, so it gets the same checks. */
(function () {
  var CARRY_KEY = 'sm-portrait-carry';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    if (typeof window.smFormatMoney === 'function') return window.smFormatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function scrollToEl(el) {
    el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }

  function formatOf(size) {
    return String(size).split(' ')[0];
  }

  /* ---------- Pets → Format → Size → Frame ---------- */
  function initFormat(root) {
    if (root.dataset.smReady) return;
    root.dataset.smReady = 'true';

    var sectionId = root.dataset.sectionId;
    var none = root.dataset.none || 'None';
    var defaultFrame = root.dataset.defaultFrame || 'Unframed';
    var fromLabel = root.dataset.from || 'from';
    var dataEl = root.querySelector('[data-sm-portrait-variants]');
    var form = document.getElementById('product-form-' + sectionId);
    var idInput = form && form.querySelector('input[name="id"]');
    if (!dataEl || !idInput) return;

    var variants = JSON.parse(dataEl.textContent);
    var info = root.closest('.product__info-container') || document;
    var petsRadios = info.querySelectorAll('[data-sm-pets]');
    var formatItems = root.querySelectorAll('[data-sm-format-item]');
    var sizeItems = root.querySelectorAll('[data-sm-size-item]');
    var frameItems = root.querySelectorAll('[data-sm-frame-item]');
    var sizeStep = root.querySelector('[data-sm-step="size"]');
    var frameStep = root.querySelector('[data-sm-step="frame"]');
    var single = root.querySelector('[data-sm-frame-single]');
    var singleValue = root.querySelector('[data-sm-frame-single-value]');

    /* Pets values in option order: One pet = 1 … Four pets = 4 */
    var petsValues = [];
    variants.forEach(function (v) {
      if (petsValues.indexOf(v.pets) === -1) petsValues.push(v.pets);
    });

    function ofPets(pets) {
      return variants.filter(function (v) { return v.pets === pets; });
    }

    function find(pets, size, frame) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.pets === pets && v.size === size && v.frame === frame) return v;
      }
      return null;
    }

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    function cheapest(list) {
      return list.reduce(function (min, v) { return !min || v.price < min.price ? v : min; }, null);
    }

    /* sizes of a format and frames of a size for a number of pets, in the order of the radios on the page */
    function sizesOf(pets, format) {
      var list = [];
      sizeItems.forEach(function (item) {
        var size = item.querySelector('input').value;
        if (formatOf(size) !== format) return;
        if (variants.some(function (v) { return v.pets === pets && v.size === size; })) list.push(size);
      });
      return list;
    }

    function framesOf(pets, size) {
      var list = [];
      frameItems.forEach(function (item) {
        if (find(pets, size, item.dataset.frame)) list.push(item.dataset.frame);
      });
      return list;
    }

    /* a variant for this size: keep the frame if it exists, else the default frame (Unframed), else the first
       frame, else the "none" frame */
    function forSize(pets, size, frame) {
      var frames = framesOf(pets, size);
      if (frame && frames.indexOf(frame) !== -1) return find(pets, size, frame);
      if (frames.indexOf(defaultFrame) !== -1) return find(pets, size, defaultFrame);
      if (frames.length) return find(pets, size, frames[0]);
      return find(pets, size, none) || ofPets(pets).filter(function (v) { return v.size === size; })[0] || null;
    }

    /* a size of this format: the same label if there is one (8×10" poster → 8×10" canvas), else the first */
    function forFormat(pets, format, fromSize, frame) {
      var sizes = sizesOf(pets, format);
      if (!sizes.length) return null;
      var label = fromSize.slice(formatOf(fromSize).length);
      var size = sizes.filter(function (s) { return s.slice(format.length) === label; })[0] || sizes[0];
      return forSize(pets, size, frame);
    }

    function fromText(list) {
      var min = cheapest(list);
      return min ? fromLabel + ' ' + money(min.price) : '';
    }

    /* photo and name fields: as many as pets, the rest hidden and disabled; nothing typed or chosen is cleared.
       A group with data-sm-off (names asked only by some style variations, assets/sm-variations.js) is all off. */
    function showPetFields(count) {
      info.querySelectorAll('[data-sm-pet-group]').forEach(function (group) {
        var off = group.hasAttribute('data-sm-off');
        if (group.hasAttribute('data-sm-names-variation')) group.hidden = off;
        group.querySelectorAll('[data-sm-pet]').forEach(function (field) {
          var on = !off && Number(field.dataset.smPet) <= count;
          field.hidden = !on;
          field.querySelectorAll('input').forEach(function (input) {
            input.disabled = !on;
          });
          var label = field.querySelector('.sm-upload__heading, [data-sm-pet-label]');
          if (label) label.textContent = count === 1 ? field.dataset.labelSingle : field.dataset.labelMulti;
        });
        var multi = group.querySelector('[data-sm-pet-multi]');
        if (multi) multi.hidden = count < 2;
      });

      document.querySelectorAll('[data-sm-pets-label]').forEach(function (el) {
        var labels = (el.dataset.labels || '').split(',');
        if (labels[count - 1]) el.textContent = labels[count - 1].trim();
      });
    }

    var current = byId(idInput.value) || variants[0];
    /* the server picked the starting variant (?variant= or the default format); Dawn's hidden input may still
       hold the first variant, so take the variant the format radios were rendered with */
    var checkedSize = root.querySelector('[data-sm-size]:checked');
    var checkedFrame = root.querySelector('[data-sm-frame]:checked');
    var checkedPets = info.querySelector('[data-sm-pets]:checked');
    if (checkedSize) {
      var pets = checkedPets ? checkedPets.value : current.pets;
      current = find(pets, checkedSize.value, checkedFrame ? checkedFrame.value : none) ||
        forSize(pets, checkedSize.value, checkedFrame && checkedFrame.value) || current;
    }

    function render(variant, updateUrl) {
      if (!variant) return;
      var frameChanged = current && current.frame !== variant.frame;
      current = variant;
      var pets = variant.pets;
      var format = formatOf(variant.size);
      var sizes = sizesOf(pets, format);
      var frames = framesOf(pets, variant.size);
      var list = ofPets(pets);

      petsRadios.forEach(function (radio) {
        radio.checked = radio.value === pets;
      });

      formatItems.forEach(function (item) {
        var input = item.querySelector('input');
        var ofFormat = list.filter(function (v) { return formatOf(v.size) === input.value; });
        item.hidden = !ofFormat.length;
        input.checked = input.value === format;
        var from = item.querySelector('[data-sm-from]');
        if (from) from.textContent = fromText(ofFormat);
      });

      sizeItems.forEach(function (item) {
        var input = item.querySelector('input');
        item.hidden = sizes.indexOf(input.value) === -1;
        input.checked = input.value === variant.size;
        var from = item.querySelector('[data-sm-from]');
        if (from) from.textContent = fromText(list.filter(function (v) { return v.size === input.value; }));
      });
      sizeStep.hidden = sizes.length < 2;

      frameItems.forEach(function (item) {
        var input = item.querySelector('input');
        var match = find(pets, variant.size, item.dataset.frame);
        item.hidden = !match;
        input.checked = item.dataset.frame === variant.frame;
        var price = item.querySelector('[data-sm-frame-price]');
        if (price) price.textContent = match ? money(match.price) : '';
      });
      frameStep.hidden = frames.length < 2;
      single.hidden = frames.length !== 1;
      singleValue.textContent = frames.length === 1 ? frames[0] : '';

      showPetFields(petsValues.indexOf(pets) + 1 || 1);

      /* the one value that is sent */
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
      var productForm = form.closest('product-form');
      if (productForm && typeof productForm.toggleSubmitButton === 'function') {
        var strings = window.variantStrings || {};
        productForm.toggleSubmitButton(!variant.available, variant.available ? undefined : strings.soldOut);
      }

      var priceBox = info.querySelector('[data-sm-portrait-price]');
      if (priceBox) {
        priceBox.querySelector('[data-sm-price-current]').textContent = money(variant.price);
        var was = priceBox.querySelector('[data-sm-price-was]');
        var showWas = variant.compare > variant.price;
        was.hidden = !showWas;
        if (showWas) was.querySelector('[data-sm-price-was-amount]').textContent = money(variant.compare);
      }

      /* "Add to Cart · $X" (assets/sm-product.js listens to this Dawn event) */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: { sectionId: sectionId, html: null, variant: { id: variant.id, price: variant.price, available: variant.available } },
        });
      }

      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      updateSwitchLinks(variant);

      /* the frame changed with the pets or size (the old one does not exist there): photos follow it
         (assets/sm-variations.js); a frame chosen by hand sends its own change event */
      if (frameChanged && !userFrame) {
        document.dispatchEvent(new CustomEvent('sm:portrait-frame', { detail: { frame: variant.frame } }));
      }
    }

    var userFrame = false;

    function onChange(event) {
      var input = event.target;
      userFrame = input.hasAttribute('data-sm-frame');
      if (input.hasAttribute('data-sm-pets')) {
        /* keep size and frame if they exist for this number of pets, else the same format, else the cheapest */
        render(
          forSize(input.value, current.size, current.frame) ||
            forFormat(input.value, formatOf(current.size), current.size, current.frame) ||
            cheapest(ofPets(input.value)),
          true
        );
      } else if (input.hasAttribute('data-sm-format')) {
        render(forFormat(current.pets, input.value, current.size, current.frame), true);
      } else if (input.hasAttribute('data-sm-size')) {
        render(forSize(current.pets, input.value, current.frame), true);
      } else if (input.hasAttribute('data-sm-frame')) {
        render(find(current.pets, current.size, input.value), true);
      }
    }

    root.addEventListener('change', onChange);
    petsRadios.forEach(function (radio) {
      radio.addEventListener('change', onChange);
    });
    /* a style variation switched its name fields on or off */
    document.addEventListener('sm:portrait-refresh', function () {
      showPetFields(petsValues.indexOf(current.pets) + 1 || 1);
    });

    render(current, false);
  }

  /* ---------- Style links keep pets, size and frame ---------- */
  function variantKey(parts) {
    return parts.filter(function (part) { return part; }).join(' / ');
  }

  function defaultFrame() {
    var root = document.querySelector('[data-sm-portrait-format]');
    return (root && root.dataset.defaultFrame) || 'Unframed';
  }

  function updateSwitchLinks(variant) {
    document.querySelectorAll('[data-sm-switch-link]').forEach(function (link) {
      if (!link.dataset.base) link.dataset.base = link.getAttribute('href').split('?')[0];
      var map;
      try {
        map = JSON.parse(link.dataset.smVariants);
      } catch (e) {
        return;
      }
      var id = map[variantKey([variant.pets, variant.size, variant.frame])];
      if (!id) {
        /* same pets and size with another frame, else the same pets and format, else the neighbour's default */
        var keys = Object.keys(map);
        var prefix = variant.pets ? variant.pets + ' / ' : '';
        var ofPets = keys.filter(function (k) { return k.indexOf(prefix) === 0; });
        var ofSize = ofPets.filter(function (k) { return k.slice(prefix.length).split(' / ')[0] === variant.size; });
        var sameSize = ofSize.filter(function (k) { return k.split(' / ').pop() === defaultFrame(); })[0] || ofSize[0];
        var sameFormat = ofPets.filter(function (k) { return formatOf(k.slice(prefix.length)) === formatOf(variant.size); })[0];
        id = map[sameSize || sameFormat];
      }
      link.setAttribute('href', id ? link.dataset.base + '?variant=' + id : link.dataset.base);
    });
  }

  /* ---------- Names and options carry over to the neighbour page ---------- */
  function carryFields(form) {
    var fields = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('properties[') !== 0 || el.type === 'file') return;
      if (el.type === 'radio' && !el.checked) return;
      if (el.value) fields[el.name] = el.value;
    });
    try {
      sessionStorage.setItem(CARRY_KEY, JSON.stringify(fields));
    } catch (e) {}
  }

  function restoreFields(form) {
    var fields;
    try {
      fields = JSON.parse(sessionStorage.getItem(CARRY_KEY) || 'null');
      sessionStorage.removeItem(CARRY_KEY);
    } catch (e) {
      return;
    }
    if (!fields) return;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!(el.name in fields) || el.type === 'file') return;
      if (el.type === 'radio') {
        if (el.value === fields[el.name]) el.checked = true;
      } else if (!el.value) {
        el.value = fields[el.name];
      }
    });
  }

  /* ---------- Required fields ---------- */
  function initValidation(sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    var button = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!form || !button || button.dataset.smPortraitGuard) return;
    button.dataset.smPortraitGuard = 'true';

    function required() {
      return Array.prototype.filter.call(form.elements, function (el) {
        return el.required && !el.disabled && el.name && el.name.indexOf('properties[') === 0;
      });
    }

    function fieldset(el) {
      return el.closest('[data-sm-pfield]');
    }

    function showChoiceError(group, show) {
      var error = group.querySelector('[data-sm-pfield-error]');
      if (!error) return;
      error.textContent = show ? group.dataset.msgRequired : '';
      error.hidden = !show;
      group.classList.toggle('has-error', show);
    }

    /* radios: message next to the group, cleared on choice (disabled ones too: a style variation may enable them) */
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.required || el.type !== 'radio') return;
      var group = fieldset(el);
      if (!group) return;
      el.addEventListener('invalid', function (event) {
        event.preventDefault();
        showChoiceError(group, true);
      });
      el.addEventListener('change', function () {
        showChoiceError(group, false);
      });
    });

    /* first empty required field, in page order (photos, background, extra) */
    function firstInvalid(report) {
      var first = null;
      var seen = {};
      required().forEach(function (el) {
        if (el.type === 'radio') {
          if (seen[el.name]) return;
          seen[el.name] = true;
        }
        var valid = report ? el.checkValidity() : el.validity.valid;
        if (!valid && !first) first = el;
      });
      return first;
    }

    function container(el) {
      return el.closest('[data-sm-upload]') || fieldset(el) || el;
    }

    button.addEventListener(
      'click',
      function (event) {
        var first = firstInvalid(true);
        if (!first) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollToEl(container(first));
        first.focus({ preventScroll: true });
      },
      true
    );

    /* links to the other styles carry the typed fields */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-sm-switch-link]')) carryFields(form);
    });

    restoreFields(form);
  }

  function run() {
    document.querySelectorAll('[data-sm-portrait-format]').forEach(function (root) {
      initValidation(root.dataset.sectionId);
      initFormat(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
